import React, { useEffect, useRef } from 'react';
import neurocinema from '../../../media/img/home/home_neurocinema.jpg';
import prevencion from '../../../media/img/home/home_prevencion.jpg';
import './productsWonderaly.scss';

const productsWonderalyData = [
  {
    id: 1,
    icon: neurocinema,
    title: 'NEUROCINEMA PROJECT',
    subtitulo: 'DONDE LA NEUROCIENCIA SE ENCUENTRA CON EL CINE',
    description: `El Neurocinema Project es un enfoque pionero que integra la neuropsicología científica en todas las fases de la producción audiovisual. Desde la preproducción hasta la postproducción, analizamos guiones, personajes, montaje y música desde una perspectiva neuro-psicológica para maximizar el impacto emocional en el espectador.

Actualmente aplicado en la película "Somos Reyes", nuestro equipo ha desarrollado informes neuropsicológicos detallados que han guiado decisiones clave de montaje y narrativa, mejorando la conexión emocional de la obra con su audiencia.

Utilizamos herramientas de IA y Business Intelligence para analizar datos emocionales y conductuales, predecir la respuesta del público y optimizar cada elemento de la producción con base en evidencia científica.`,
    link: '',
  },
  {
    id: 2,
    icon: prevencion,
    title: 'PREVENCIÓN DEL SUICIDIO',
    subtitulo: 'TECNOLOGÍA E IMPACTO SOCIAL EN EXTREMADURA',
    description: `El Proyecto de Prevención del Suicidio en Adolescentes y Jóvenes en Extremadura combina estrategias educativas, tecnológicas y comunitarias para reducir las tasas de suicidio en esta población vulnerable.

Utilizando herramientas avanzadas de IA y Business Intelligence, monitorizamos y analizamos datos en tiempo real para identificar patrones y señales de riesgo. El proyecto incluye intervención proactiva, educación y concienciación, y colaboración multidisciplinaria con instituciones educativas y servicios de salud.

Con un presupuesto de 250.000€ y una planificación a 2 años, este proyecto está diseñado para ser escalable a nivel nacional e internacional, compartiendo conocimientos y mejores prácticas con otras regiones.`,
    link: '',
  },
];

const ProductsWonderaly = () => {
  const headerRefs = useRef([]);
  const lineRefs = useRef([]);

  useEffect(() => {
    const observerOptions = {
      threshold: 0.2,
      rootMargin: '0px 0px 500px 0px',
    };

    const headerObservers = headerRefs.current.map((headerRef, index) => {
      if (!headerRef) return null;
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const direction = index % 2 === 0 ? 'right' : 'left';
            entry.target.classList.add(
              `productWonderaly__media-${direction}-visible`,
            );
            observer.unobserve(entry.target);
          }
        });
      }, observerOptions);
      observer.observe(headerRef);
      return observer;
    });

    return () => {
      headerObservers.forEach((obs) => obs?.disconnect());
    };
  }, []);

  useEffect(() => {
    const observerOptions = {
      threshold: 0.2,
      rootMargin: '0px 0px 0px 0px',
    };

    const lineObservers = lineRefs.current.map((lineRef) => {
      if (!lineRef) return null;
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('content__title-line--visible');
            observer.unobserve(entry.target);
          }
        });
      }, observerOptions);
      observer.observe(lineRef);
      return observer;
    });

    return () => {
      lineObservers.forEach((obs) => obs?.disconnect());
    };
  }, []);

  return (
    <div className="productWonderaly-info">
      <div className="productWonderaly__header">
        <h1 className="content__title-backgroundDark">
          Conoce más sobre nuestros proyectos
        </h1>
        <div
          ref={(el) => (lineRefs.current[0] = el)}
          className="content__title-line"
        />
      </div>
      <div className="productWonderaly__container">
        {productsWonderalyData.map((product, index) => (
          <div className="productWonderaly__container-product" key={product.id}>
            <div
              className={`productWonderaly__section ${index % 2 !== 0 ? 'reverse' : ''}`}
            >
              <div
                ref={(el) => (headerRefs.current[index] = el)}
                className={`productWonderaly__media ${index % 2 !== 0 ? 'reverse-text productWonderaly__media-left' : 'productWonderaly__media-right'}`}
              >
                <div className="productWonderaly__img-container">
                  <img
                    src={product.icon}
                    alt={product.title}
                    className={`productWonderaly__image ${index % 2 !== 0 ? 'reverse-text' : ''}`}
                  />
                </div>
              </div>
              <div className="productWonderaly__content">
                <h2 className="productWonderaly__title">{product.title}</h2>
                <h4 className="productWonderaly__subtitle">
                  {product.subtitulo}
                </h4>
                <p className="productWonderaly__text content__text-title-backgroundDark">
                  {product.description}
                </p>
              </div>
            </div>
            {index !== productsWonderalyData.length - 1 && (
              <hr className="divider diverdermedia" />
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default ProductsWonderaly;
